<div class="wrapper-panel-dashboard">
	<div class="panel panel-card panel-dashboard-filters">
		<div>
			<i class="material-icons">manage_search</i>
			<h2 data-testid="SUBSYS2_DASHBOARD_FILTERS_TITLE_TXT">{{ labels().DASHBOARD_FILTERS_COMPONENT_TITLE }}</h2>
		</div>
		<div class="dashboard-filter">
			<div class="form-group pb-0">
				<div class="input-group">
					<input data-testid="SUBSYS2_DASHBOARD_FILTERS_PATIENT_INPUT" type="text" autocomplete="off"
						class="form-control" id="PatientList" [placeholder]="labels().DASHBOARD_FILTERS_COMPONENT_SELECT_PATIENT"
						[ngbTypeahead]="filterPatients" [focusFirst]="true" [inputFormatter]="patientFormatter"
						[resultFormatter]="patientFormatter" [editable]="false" #patientAutocomplete="ngbTypeahead"
						(focus)="showPatientList(patientAutocomplete)" (blur)="reset(patientAutocomplete)"
						(selectItem)="updatePatient($event, patientAutocomplete)" />
					<i data-testid="SUBSYS2_DASHBOARD_FILTERS_PATIENT_CLEAR_BTN"
						class="material-icons input-group-append align-self-center" (click)="clear(patientAutocomplete)"
						(keypress)="clear(patientAutocomplete)">clear</i>
				</div>
			</div>
		</div>
	</div>
</div>